/** @jsxImportSource @emotion/react */
import { Grid, IconButton, Typography } from '@mui/material';
import React from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import VideoCameraBackIcon from '@mui/icons-material/VideoCameraBack';
import { useState } from 'react';

function UploadedDocuments(props) {
    const { reviewData, setUploadedDocProofID } = props

    return (
        <Grid container css={{padding:"10px"}} alignItems="center" spacing={3}>
            {reviewData?.kycStagingFormProofUpload.map(uploadedDoc =>
                <Grid item xs={6} md={4}>
                    <Grid container alignItems={"center"} onClick={()=>setUploadedDocProofID(uploadedDoc.kycstgProofId)} 
                        css={{cursor:"pointer", border:"1px solid lightgrey", borderRadius:"5px", padding:"10px"}}
                    >
                        <Grid item css={{width:"100%", textAlign:"center"}}>
                            {(uploadedDoc.fileType.toLowerCase() === "jpg" || uploadedDoc.fileType.toLowerCase() === "jpeg" || uploadedDoc.fileType.toLowerCase() === "png") ? 
                                <ImageIcon color="primary" css={{width:"40px", height:"40px"}}/>
                                : (uploadedDoc.fileType.toLowerCase() === "mp4" || uploadedDoc.fileType.toLowerCase() === "mov") ? 
                                    <VideoCameraBackIcon color="primary" css={{width:"40px", height:"40px"}} />
                                    : uploadedDoc.fileType.toLowerCase() === "pdf" &&
                                        <PictureAsPdfIcon color="primary" css={{width:"40px", height:"40px"}}/>
                            }
                        </Grid>
                        <Grid item css={{width:"100%", textAlign:"center"}}>
                            <Typography variant="body">
                                {/* uploadedDoc.documentSubType +"-"+  */uploadedDoc.documentName}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
}

export default UploadedDocuments;